var HM_TEAMS = [
  {name:"Aarthy S",desgn:"Content Development",picture:"aarthy.jpg"},
  {name:"Abdul Kadhar S ",desgn:"UI Development",picture:"abdul.jpg"},
  {name:"Ananda Kumar A ",desgn:"HTML5 Development",picture:"anand.jpg"},
  {name:"Angela Susan Mathews ",desgn:"Content Development",picture:"angela.jpg"},
  {name:"Antony A ",desgn:"HTML5 Development",picture:"antony.jpg"},
  {name:"Balakumar VK ",desgn:"Content Development",picture:"bala.jpg"},
  {name:"Bavuyise Mtana ",desgn:"Customer Engagement",picture:"bavuyise.jpg"},
  {name:"Benny Geo G ",desgn:"HTML5 Development",picture:"benny.jpg"},
  {name:"Bhavya B ",desgn:"Content Development",picture:"bhavya.jpg"},
  {name:"Bhuvana S ",desgn:"Content Development",picture:"bhuvana.jpg"},
  {name:"Daniel Kinch ",desgn:"Content Development",picture:"daniel-kinch.jpg"},
  {name:"Deepika Nair ",desgn:"UI Development",picture:"deepika_n.jpg"},
  {name:"Dhamimun Nisha ",desgn:"Animation",picture:"nisha.jpg"},
  {name:"Divya Srinivasan ",desgn:"Finance & Accounts",picture:"divya.jpg"},
  {name:"Dlamini Gerald ",desgn:"Customer Engagement",picture:"dlamini.jpg"},
  {name:"Dumisani Nyamane ",desgn:"Customer Engagement",picture:"dumisani.jpg"},
  {name:"Frank Tlaletsi ",desgn:"Customer Engagement",picture:"frank.jpg"},
  {name:"Frank Van Schalkwyk ",desgn:"Customer Engagement",picture:"frankV.jpg"},
  {name:"Gayathri H ",desgn:"Customer Engagement",picture:"gayathri.jpg"},
  {name:"Geetha Ramanujam ",desgn:"Content Development",picture:"geetha.jpg"},
  {name:"Hemachandran S ",desgn:"Data Analysis",picture:"hemachandran.jpg"},
  {name:"Jai Karthik R ",desgn:"Mobile App Development",picture:"jaikarthik.jpg"},
  {name:"Jayapackiam T.N ",desgn:"Content Development",picture:"jaya.jpg"},
  {name:"Jayashree Gautham ",desgn:"Customer Engagement",picture:"jayashree-gautham.jpg"},
  {name:"Jona Sherly ",desgn:"Software Development",picture:"jona-sherly.jpg"},
  {name:"Kaliyaperumal V ",desgn:"Animation",picture:"kaliyaperumal.jpg"},
  {name:"Karikalan M ",desgn:"Content Development",picture:"karikalan.jpg"},
  {name:"Krishna Gaurav ",desgn:"UI/UX Design",picture:"krishna-gaurav.jpg"},
  {name:"Ladongnuklu Jamir ",desgn:"Product Marketing",picture:"ladang.jpg"},
  {name:"Lakshmidaran M ",desgn:"UI Design",picture:"lucky.jpg"},
  {name:"Luthando Makinza ",desgn:"Customer Engagement",picture:"luthando.jpg"},
  {name:"Mbuso Ncube ",desgn:"Customer Engagement",picture:"mbuso.jpg"},
  {name:"Narayanan K ",desgn:"Quality Assurance",picture:"narayanan.jpg"},
  {name:"Naveen P ",desgn:"HTML5 Development",picture:"naveen.jpg"},
  {name:"Nirmala Agadgar ",desgn:"Software Development",picture:"nirmala.jpg"},
  {name:"Paballo Moses Moloi ",desgn:"Tech Infrastructure",picture:"paballa.jpg"},
  {name:"Padmini Ravi ",desgn:"Content Development",picture:"padmini.jpg"},
  {name:"Pavithra R ",desgn:"Content Development",picture:"pavithra.jpg"},
  {name:"Porsha Megan Norton ",desgn:"Customer Engagement",picture:"porsha.jpg"},
  {name:"Prabhakaran R ",desgn:"HTML5 Development",picture:"prabhakaran.jpg"},
  {name:"Radhika R ",desgn:"HTML5 Development",picture:"radika.jpg"},
  {name:"Raghavendiran A ",desgn:"HTML5 Development",picture:"ragavendar.jpg"},
  {name:"Raja M ",desgn:"Mobile App Development",picture:"raja.jpg"},
  {name:"Ranjan Ray Chaudhuri ",desgn:"Finance & Accounts",picture:"ranjan.jpg"},
  {name:"Sai Bharath ",desgn:"Quality Assurance",picture:"sai.jpg"},
  {name:"Sangeetha Chittibabu ",desgn:"Content Development",picture:"sangeetha.jpg"},
  {name:"Sankarapandian T ",desgn:"Software Development",picture:"sankar.jpg"},
  {name:"Saranya S ",desgn:"Customer Operations",picture:"saranya.jpg"},
  {name:"Satheesh S ",desgn:"Content Development",picture:"sathish.jpg"},
  {name:"Sathish Kumar V ",desgn:"Tech Infrastructure",picture:"sathishtec.jpg"},
  {name:"Shanthi Arunachalam ",desgn:"HTML5 Development",picture:"shanthi.jpg"},
  {name:"Sheela Shankar ",desgn:"Customer Engagement",picture:"sheela.jpg"},
  {name:"Shriram N ",desgn:"Software Development",picture:"shriram.jpg"},
  {name:"Shyam Sundar G ",desgn:"Software Development",picture:"shyamg.jpg"},
  {name:"Shyam Sundar V ",desgn:"HTML5 Development",picture:"shyam.jpg"},
  {name:"Sivakumar P ",desgn:"Human Capital Management",picture:"shiva.jpg"},
  {name:"Sureka SR ",desgn:"Animation",picture:"sureka.jpg"},
  {name:"Suresh S ",desgn:"Content Development",picture:"suresh.jpg"},
  {name:"Swetha Sekar ",desgn:"Customer Engagement",picture:"swetha.jpg"},
  {name:"Tamizh Selvi N ",desgn:"Admin & Procurement",picture:"tamilselvi.jpg"},
  {name:"Thapelo Nyoni ",desgn:"Customer Engagement",picture:"thapelo.jpg"},
  {name:"Tharani Dushendra ",desgn:"Content Development",picture:"tharani.jpg"},
  {name:"Thato Gloria Botlhoko ",desgn:"Admin & Procurement",picture:"thato-botlhoko.jpg"},
  {name:"Thejasvi Parthasarathy ",desgn:"Customer Engagement",picture:"thejasvi-parthasarathy.jpg"},
  {name:"Udaya Kumar K ",desgn:"Finance & Accounts",picture:"uday.jpg"},
  {name:"Veenus Vivie B ",desgn:"Admin & Procurement",picture:"veenus.jpg"},
  {name:"Venugopal G ",desgn:"Tech Infrastructure",picture:"venu.jpg"},
  {name:"Vijayakumar R ",desgn:"Audio Development",picture:"vijay.jpg"},
  {name:"Vinitha R ",desgn:"Content Development",picture:"vinitha.jpg"},
  {name:"Yuvaraja C ",desgn:"Content Development",picture:"yuvaraj.jpg"}
  ];


module.exports = HM_TEAMS;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/H-Teams.js